<div class="notifications">
  <section v-if="profileRequests.rows.length || profileRequests.error" class="notifications__entry mb-3">
    <h6>{{ $t('profileRequests.title') }}</h6>
    <p v-if="profileRequests.error" role="alert">{{ $t('profileRequests.inboxError') }}</p>
    <button v-for="row in profileRequests.rows" :key="row.documentId" type="button" class="app-link-button d-flex text-start mb-2" @click="requestPlayer = row.player">
      <i class="bi bi-lightbulb-fill" :class="row.state === 'waiting' ? 'text-muted' : 'text-warning'" aria-hidden="true"></i>
      <span>{{ row.player.name }}<small class="d-block text-muted">{{ $t('profileRequests.' + row.state) }}</small></span>
    </button>
  </section>
  <PlayerProfileRequestsModal v-if="requestPlayer && profileRequests.clubId" :player="requestPlayer" :club-id="profileRequests.clubId" @close="requestPlayer = null" />
  <ChangelogFeed ref="feed" :show-empty="!profileRequests.rows.length && !profileRequests.error" @unread-change="$emit('unread-change', $event)" @open-history="$emit('open-history')" />
</div>
